<template>
  <card class="card-user">
    <p class="card-text"></p>
    <div class="author">
      <div class="block block-one"></div>
      <div class="block block-two"></div>
      <div class="block block-three"></div>
      <div class="block block-four"></div>
      <a href="javascript:void(0)">
        <h5 class="title">{{account.user.name}} {{account.user.surname}}</h5>
      </a>
      <p class="description">
        <span v-for="role in account.user.roles" :key="role" v-if="role !== 'subscriber'">{{role}}</span>
      </p>
    </div>
    <p class="text-center"> <b>Firma personale: </b> <br>
      <img :src="this.account.user.signature" alt=""> </p>
    <div class="card-description">
    </div>

    <div slot="footer" class="button-container">
    </div>
  </card>
</template>
<script>
  import { mapState } from 'vuex'

  export default {
    name: 'user-profile',
    computed: {
      ...mapState({
        account: state => state.account,
      })
    }

  };
</script>
<style></style>
